import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import PriceSummaryInfo from '../types/PriceSummaryInfo';
import { getPriceSummaryInfo } from '../api/productSummary.api';

type PricesummaryInfoData = {
  startDuration: string;
  endDuration: string;
  refreshTime: string;
};

export type PriceSummaryInfoState = FetchState<PricesummaryInfoData>;

type PriceSummaryInfoFetchProps = {
  sourceOwnerId: string;
};

const initialState: PriceSummaryInfoState = {
  loading: false,
  error: false,
  data: null,
};

const usePriceSummaryInfoFetch = ({ sourceOwnerId }: PriceSummaryInfoFetchProps): [PriceSummaryInfoState] => {
  const params: PriceSummaryInfo.Request = {
    sourceOwnerId,
  };

  const [{ loading, data, error }] = useFetchReducer(() => getPriceSummaryInfo(params), [sourceOwnerId]);
  const state: PriceSummaryInfoState = { ...initialState, loading, error };

  if (data === null) {
    return [state];
  }

  return [
    {
      ...state,
      data,
    },
  ];
};

export default usePriceSummaryInfoFetch;
